import {ImageRequestParams} from "./image-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../core/app/consts";

export class AssetsRequestParams extends ImageRequestParams {
  constructor(width: Number,height: Number, color: String) {
    super({resourceName: 'Website/AssetsSVGNewBrand', width, height, color});

    this.version = 2;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
